import { FormGroup, AbstractControl, FormControl } from '@angular/forms';

// custom validator to check that two fields match
export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];
        

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}

export function dobIsOldEnough(control: AbstractControl){
    if(control.value.length > 0 && control.value.length != 10){
        return {'invalid_date': true};
    }
    let date_components = control.value.split('/');
    if(parseInt(date_components[0]) > 31){
        return {'invalid_date': true};
    }
    if(parseInt(date_components[1]) > 12){
        return {'invalid_date': true};
    }

    let now = new Date();
    if(parseInt(date_components[2]) > now.getFullYear()){
        return {'invalid_date': true};
    }

    if(parseInt(date_components[2]) < 1900){
        return {'before_1900': true};
    }

    // 
    let birthDate = new Date(parseInt(date_components[2]), parseInt(date_components[1]) - 1, parseInt(date_components[0]));
    if(birthDate.getDate() != parseInt(date_components[0]) || birthDate.getMonth() != parseInt(date_components[1]) - 1 || birthDate.getFullYear() != parseInt(date_components[2])){
        return {'invalid_date': true};
    }

    let userIs18 = false;
    let age = now.getTime() - birthDate.getTime();
    age = age / (1000 * 60 * 60 * 24 * 365.25);
    if(age >= 18){
        userIs18 = true;
    }
    
    if(!userIs18){
        return {'min_18': true};
    }

    return null;
}

/**
 * Dynamic DOB validator factory function
 * @param minAge - The minimum age required (e.g., 16 or 18)
 * @returns Validation function
 */
export function dobMinAgeValidator(minAge: number = 18) {
    return (control: AbstractControl) => {
        if (!control.value) {
            return null; // Let required validator handle empty values
        }

        if (control.value.length > 0 && control.value.length !== 10) {
            return { 'invalid_date': true };
        }

        const date_components = control.value.split('/');
        
        // Validate day (1-31)
        const day = parseInt(date_components[0]);
        if (isNaN(day) || day < 1 || day > 31) {
            return { 'invalid_date': true };
        }

        // Validate month (1-12)
        const month = parseInt(date_components[1]);
        if (isNaN(month) || month < 1 || month > 12) {
            return { 'invalid_date': true };
        }

        // Validate year
        const year = parseInt(date_components[2]);
        const currentYear = new Date().getFullYear();
        if (isNaN(year) || year > currentYear) {
            return { 'invalid_date': true };
        }

        // Minimum year is 1900
        if (year < 1900) {
            return { 'before_1900': true };
        }

        // Create date object to validate the actual date
        const birthDate = new Date(year, month - 1, day);
        if (birthDate.getDate() !== day || birthDate.getMonth() !== month - 1 || birthDate.getFullYear() !== year) {
            return { 'invalid_date': true };
        }

        // Calculate age more precisely
        const today = new Date();
        let age = today.getFullYear() - year;
        
        // Adjust age if birthday hasn't occurred this year
        const hasHadBirthdayThisYear = (today.getMonth() > month - 1) || 
            (today.getMonth() === month - 1 && today.getDate() >= day);
        
        if (!hasHadBirthdayThisYear) {
            age--;
        }

        if (age < minAge) {
            return minAge === 16 ? { 'min_16': true } : { 'min_18': true };
        }

        return null;
    };
}

export function PostcodeValidate(control: AbstractControl){
    if(control.value == ''){
        return null;
    }
    
    if(
        !/^[a-zA-Z]*$/g.test(control.value.trim().substring(0,1)) || 
        !/^[a-zA-Z]*$/g.test(control.value.trim().substring(control.value.trim().length,control.value.trim().length-1)) ||
        control.value.trim().length < 5 ||
        control.value.trim().length > 8 ||
        !/\d+/.test(control.value.trim())
    ){
        return {'invalid_postcode': true };
    }

    if(control.hasError('invalid_postcode_uk')){
        return {invalid_postcode_uk: true};
    }

    return null;
}

export interface ValidationResult {
    [key: string]: boolean;
}

export class RegisterFormValidator {

    public static strong(control: FormControl): ValidationResult {
        // Enforce consistent password rules: 8-20 characters, capital letter, lowercase letter, symbol, number
        let hasNumber = /\d/.test(control.value);
        let hasUpper = /[A-Z]/.test(control.value);
        let hasLower = /[a-z]/.test(control.value);
        let hasSpecialCharacter = /[£€`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(control.value);
        
        const valid = hasNumber && hasUpper && hasLower && hasSpecialCharacter && 
                     control.value.length >= 8 && control.value.length <= 20;
        
        if (!valid) {
            // return what´s not valid
            return { strong: true };
        }

        return null;
    }

    public static email(control: FormControl): ValidationResult {
      if(control.value && control.value.indexOf('.') == -1){
        return {email: true};
      }

      return null;
    }
}